export default __webpack_public_path__ + "static/media/siemens-logo-petrol.d3a18e49.svg";